var _path, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackpackIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0522 44.8349L36.035 22.4057L35.7882 23.6763L35.7243 24.0057L35.8719 24.3069L45.948 44.8729L44.7924 50.099L41.3861 54H39.1963L36.4529 42.2275L36.0713 40.5901L34.8147 41.7069L34.7726 41.7444L34.533 41.9573L34.4618 42.2699L31.7996 53.9625H29.6145L26.2121 50.0576L25.0522 44.8349Z",
    stroke: "black",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_3773_17430",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 44.2188H27.5318L28.6766 50.034H27.1489L26 44.2188Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26 44.2188V42.2188H23.5662L24.0379 44.6064L26 44.2188ZM27.5318 44.2188L29.4942 43.8325L29.1765 42.2188H27.5318V44.2188ZM28.6766 50.034V52.034H31.1087L30.6389 49.6477L28.6766 50.034ZM27.1489 50.034L25.1868 50.4217L25.5054 52.034H27.1489V50.034ZM26 46.2188H27.5318V42.2188H26V46.2188ZM25.5695 44.605L26.7142 50.4203L30.6389 49.6477L29.4942 43.8325L25.5695 44.605ZM28.6766 48.034H27.1489V52.034H28.6766V48.034ZM29.111 49.6464L27.9621 43.8311L24.0379 44.6064L25.1868 50.4217L29.111 49.6464Z",
    fill: "black",
    mask: "url(#path-3-inside-1_3773_17430)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_3773_17430",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1484 50.0312H28.6761L32.1228 54.4728H30.591L27.1484 50.0312Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.1484 50.0312V48.0312H23.0679L25.5677 51.2565L27.1484 50.0312ZM28.6761 50.0312L30.2562 48.8051L29.6556 48.0312H28.6761V50.0312ZM32.1228 54.4728V56.4728H36.2064L33.7029 53.2467L32.1228 54.4728ZM30.591 54.4728L29.0102 55.6981L29.6107 56.4728H30.591V54.4728ZM27.1484 52.0312H28.6761V48.0312H27.1484V52.0312ZM27.0961 51.2574L30.5428 55.699L33.7029 53.2467L30.2562 48.8051L27.0961 51.2574ZM32.1228 52.4728H30.591V56.4728H32.1228V52.4728ZM32.1718 53.2476L28.7292 48.806L25.5677 51.2565L29.0102 55.6981L32.1718 53.2476Z",
    fill: "black",
    mask: "url(#path-5-inside-2_3773_17430)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-3_3773_17430",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8595 20.5H36.3317L26 44.219H27.5318L37.8595 20.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.8595 20.5L39.6932 21.2984L40.9117 18.5H37.8595V20.5ZM36.3317 20.5V18.5H35.0214L34.4981 19.7013L36.3317 20.5ZM26 44.219L24.1664 43.4203L22.9473 46.219H26V44.219ZM27.5318 44.219V46.219H28.8424L29.3656 45.0175L27.5318 44.219ZM37.8595 18.5H36.3317V22.5H37.8595V18.5ZM34.4981 19.7013L24.1664 43.4203L27.8336 45.0177L38.1653 21.2987L34.4981 19.7013ZM26 46.219H27.5318V42.219H26V46.219ZM29.3656 45.0175L39.6932 21.2984L36.0258 19.7016L25.6981 43.4206L29.3656 45.0175Z",
    fill: "black",
    mask: "url(#path-7-inside-3_3773_17430)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackpackIcon);
export default __webpack_public_path__ + "static/media/backpack-icon.2f384abbd546d44cc5fdfd717b5f5584.svg";
export { ForwardRef as ReactComponent };